<template>
  <li class="ListItem">
    <div>
      {{ item[itemName] }}

      <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" @click="$emit('remove')">
        <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
          <polyline points="11.5 5.5 10.5 13.5 3.5 13.5 2.5 5.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></polyline>
          <line x1="1" y1="3.5" x2="13" y2="3.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
          <path d="M4.46,3.21l0-1.73a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1v2" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
        </g></g>
      </svg>
    </div>
  </li>
</template>

<script>

export default {
  props: {
    item: Object,
    itemName: String,
  },
}

</script>

<style scoped>

li {
  position: relative;
  list-style: none;
}

li + li > div {
  border-top: 1px solid #D1D3D4;
}

svg {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: rgb(130,130,130);
  cursor: pointer;
}

svg:hover {
  color: currentColor;
}

</style>
